<template>

  <div class="wrapper">

    <v-row no-gutters class="waiting">
      <h3>Olá, <span class="name">{{name}}</span> </h3>
      <p v-if="!queueID">Entrando na lista de prioridade...</p>
      <p v-if="queueID">Em poucos minutos um atendente irá iniciar o atendimento, não feche a janela.</p>
      <!-- <p v-if="!joined">Entrando na fila de espera...</p> -->
      <v-progress-circular width="5" :size="48" class="loading" indeterminate></v-progress-circular>
    </v-row>

  </div>
</template>

<script>
export default {
    name: "Waiting",
    data: () => ({
      name: "Visitante",
      queueID: null,
      anwser: false
    }),
    mounted(){
      const localData = JSON.parse(localStorage.getItem('@bsi:user'));

      if(!localData) return window.location.replace("signin");
      
      this.name = localData.nome;
      this.enterQueue(localData.id);

      setTimeout(() => {

        if(!this.anwser) {
          this.$socket.emit("filas_cancel", { fila_id: this.queueID });
          return this.$router.push({ name: 'Offline' });
        }

      }, 40000);

    },
    methods: {
      enterQueue(userID){
        this.$socket.emit("filas_create", { cliente_id: userID });
      }
    },
    sockets:{
      filas_create: function(response){
        const { id } = response.payload;
        this.queueID = id;
      },
      atendimentos_create: async function({atendimentoID}){
        this.anwser = true;
        this.$router.push({name: 'Room', params: { roomID: atendimentoID } });
      }
    },
}
</script>

<style lang="scss" scoped>

  .wrapper{
    
    background-color: var(--v-secondary-base);
    color: var(--v-text-base);

    .waiting{

      width: 25vw;
      min-width: 300px;
      display: block;
      padding: 40px 20px;

      .name{
        color: var(--v-primary-base);
        font-weight: bold;
      }
      h3{
        font-size: 26px;
        font-weight: 400;
        text-align: center;
      }
      p{
        font-size: 14px;
        text-align: center;
        padding: 20px 0;
      }
      .loading{
        display: block;
        margin: 0 auto;
      }
      img{
        display: block;
        margin-top: 20px;
        margin-left: auto;
      }

    }
   
  }

</style>